'use strict';
var toString = Object.prototype.toString;

module.exports = function (x) {
	return toString.call(x) === '[object Function]';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-fn/index.js
// module id = 24
// module chunks = 0